import { useQuery } from "@apollo/client";

import { GqlMapEditorGetLayerAllFeaturesParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { MapEditorGetAllLayerFeaturesDocument } from "./useMapEditorGetAllLayerFeatures.generated";

export default function useMapEditorGetAllLayerFeatures(
    projectId: string,
    params: GqlMapEditorGetLayerAllFeaturesParams,
) {
    const { data, loading, error, previousData } = useQuery(MapEditorGetAllLayerFeaturesDocument, {
        variables: { projectId, params },
    });

    const result = loading ? previousData?.mapEditorGetAllLayerFeatures : data?.mapEditorGetAllLayerFeatures;

    const [filterOptions] = useCacheFilterOptions(result?.filterOptions);

    return {
        loading,
        error,
        filterOptions,
        data: result?.data,
    };
}
